<template>
    <div>
        <common-table :limitHeight="true" :table-columns="tableColumns" :url="url" :operate="operate"
            :form-fields="formFields" :permission="permission" :buttons="buttons" :searchs="searchs"
            @returnId="returnId" @addCreateRule="addCreateRule" pageName="ShutDownDueToOverallLosses" ref="table"
            @isPageSmall="isPageSmall"></common-table>
        <el-drawer :visible.sync="showAddCreateRulePopup" :size="pageSmall ? '100%' : '50%'" direction="rtl"
            :withHeader="false">
            <div class="addCreateRuleBox ">
                <div class="createRuleTitle flex-between alcenter">
                    创建规则
                    <i class="el-icon-close" @click="closeRulePopup"></i>
                </div>
                <div class="setRuleContent">
                    <div class="oe-drawer-guide">
                        <guide-panel dense
                            title="全域亏损关停规则说明"
                            summary="这张表单用于给账户、计划、抖音号或商品建立自动止损规则。命中条件后，系统可以自动关停并通知，适合夜间或无人值守场景。"
                            tone="warning"
                            icon="el-icon-warning-outline"
                            :points="[
                                '先确定监控对象是谁，再配置执行条件。',
                                '白名单里的计划不会被自动关停，建议把重点活动计划放进去。',
                                '首次启用建议先小范围试运行，避免误关停。'
                            ]"
                        />
                    </div>
                    <div class="monitorWayBox">
                        <div class="pb10 font-bold">监控方式</div>
                        <div class=" flex-between">
                            <div class="way_box text-center" :class="{ 'active_way_box': activeWayBoxIndex == index }"
                                v-for="(item, index) in monitorWayList" :key="index" @click="goSelectMonitorWay(index)">
                                <div class="font">
                                    {{ item.wayName }}
                                </div>
                                <div class="way_info pt10" :class="{ 'active_way_box': activeWayBoxIndex == index }">
                                    {{ item.info }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="monitorTargetBox">
                        <div class="pb10  font-bold">监控目标</div>
                        <div class="monitorTargetContent fs14">
                            <div>
                                <div class="flex alcenter mb-10" v-if="!activeWayBoxIndex">
                                    <el-input v-model="searchKeyWord"
                                        @clear="searchMonitorList = []; isSearching = false" clearable
                                        placeholder="搜索账户名称或ID" size="medium" class="handle-input2" />
                                    <el-button class="fs18" type="primary" size="small" @click="goSearchMonitorList(0)">
                                        搜索
                                    </el-button>
                                </div>
                                <div v-else-if="activeWayBoxIndex == 1">
                                    <div class="flex alcenter flex_wrap ">
                                        <el-select @change="getDataByAccount(0)" class="pr10 input200 mb10"
                                            v-model="selectedAccount" @focus.native.capture.stop="() => { }" filterable
                                            placeholder="请选择账户">
                                            <el-option v-for="(item, index) in accountList" :key="index"
                                                :label="item.name" :value="item.advertiserId">
                                            </el-option>
                                        </el-select>
                                        <el-select class="pr10 input120 mb10" v-model="accountPlanType" filterable
                                            placeholder="请选择账户">
                                            <el-option label="推商品" value="推商品">
                                            </el-option>
                                        </el-select>

                                        <el-select class="pr10 input150 mb10" v-model="launchValue" filterable
                                            placeholder="请选择账户">
                                            <el-option v-for="(item, index) in launchList" :key="index" :label="item"
                                                :value="item">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div class="pb20 flex alcenter flex_wrap">
                                        <el-date-picker class="dateSelector mr10 mb10" popper-class="datePicker2"
                                            @change="pickData" v-model="selectData" type="daterange" align="right"
                                            unlink-panels range-separator="至" start-placeholder="开始日期"
                                            end-placeholder="结束日期" :picker-options="pickerOptions"
                                            format="yyyy 年 MM 月 dd 日">
                                        </el-date-picker>
                                        <div class="flex alcenter ">
                                            <el-input v-model="searchKeyWord"
                                                @clear="searchMonitorList = []; isSearching = false" clearable
                                                placeholder="搜索计划名称或ID" size="medium" class="handle-input2   " />
                                            <el-button :disabled="loading" :class="{ 'w100': loading }" class=" fs18 "
                                                type="primary" size="small" @click="goSearchMonitorList(1)">
                                                <i class="el-icon-loading" v-if="loading"></i>
                                                搜索
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                                <div v-else-if="activeWayBoxIndex == 2">
                                    <div class="flex alcenter flex_wrap ">
                                        <el-select class="pr10 input250 mr10 mb10" @change="getDataByAccount(1)"
                                            v-model="selectedAccount" @focus.native.capture.stop="() => { }" filterable
                                            placeholder="请选择账户">
                                            <el-option v-for="(item, index) in accountList" :key="index"
                                                :label="item.name" :value="item.advertiserId">
                                            </el-option>
                                        </el-select>
                                        <el-input v-model="searchKeyWord"
                                            @clear="searchMonitorList = []; isSearching = false" clearable
                                            placeholder="搜索抖音号名称或ID" size="medium" class="handle-input2  mb10" />
                                        <el-button class=" fs18 mb10" type="primary" size="small"
                                            @click="goSearchMonitorList(2)">
                                            搜索
                                        </el-button>
                                    </div>
                                    <div class="pb10 c_ffb563">
                                        温馨提示：账户选择仅用于筛选抖音号，并不作为规则的一部分

                                    </div>
                                </div>
                                <div v-else-if="activeWayBoxIndex == 3">
                                    <div class="flex alcenter  flex_wrap">
                                        <el-select class="pr10 input250 mb10" v-model="selectedAccount"
                                            @change="getdyNumberList(1)" @focus.native.capture.stop="() => { }"
                                            filterable placeholder="请选择账户">
                                            <el-option v-for="(item, index) in accountList" :key="index"
                                                :label="item.name" :value="item.advertiserId">
                                            </el-option>
                                        </el-select>
                                        <el-select class="pr10 input250 mb10 mr10" @change="getProductList"
                                            v-model="selectedDYNumber" placeholder="请选择抖音号">
                                            <el-option v-for="(item, index) in dyNumberList" :key="index"
                                                :label="item.name" :value="item.id">
                                            </el-option>
                                        </el-select>
                                        <el-input v-model="searchKeyWord"
                                            @clear="searchMonitorList = []; isSearching = false" clearable
                                            placeholder="搜索商品名称或ID" size="medium" class="handle-input2  mb10  " />
                                        <el-button class="mb10 fs18" type="primary" size="small"
                                            @click="goSearchMonitorList(3)">
                                            搜索
                                        </el-button>
                                    </div>
                                    <div class="pb10 c_ffb563">
                                        温馨提示：账户选择仅用于筛选商品，并不作为规则的一部分
                                    </div>
                                </div>
                            </div>

                            <div class="selectAccountBox">
                                <div class="selectTitleBox flex alcenter">
                                    <div class="leftTitle flex alcenter">
                                        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
                                            @change="handleCheckAllChange">
                                        </el-checkbox>
                                        <span class="pr5 pl10 ">请选择{{ activeWayBoxIndex ? activeWayBoxIndex == 1 ? '计划'
                                            :
                                            activeWayBoxIndex == 2 ? '抖音号' : '商品' : '账户' }}</span>
                                        <span class=" pr5 fs12" v-if="monitorList.length">
                                            ({{ isSearching ? searchMonitorList.length : monitorList.length
                                            }})
                                        </span>
                                        <el-tooltip class="item" effect="dark"
                                            :content="activeWayBoxIndex ? '最多展示前100条，如果列表没有某条数据，请使用搜索减小范围' : '最多展示前200条，如果列表没有某条数据，请使用搜索减小范围'"
                                            placement="top">
                                            <i class="el-icon-question mt5"></i>
                                        </el-tooltip>
                                    </div>
                                    <div class="rightTitle flex-between">
                                        <div class="flex alcenter">
                                            已选 <span v-if="selectedMonitorList.length">( {{ selectedMonitorList.length
                                                }}
                                                )</span>
                                            <span v-else>{{ activeWayBoxIndex ? activeWayBoxIndex == 1 ? '计划'
                                                :
                                                activeWayBoxIndex == 2 ? '抖音号' : '商品' : '账户' }}</span>
                                        </div>
                                        <div class="c_primary" v-if="selectedMonitorList.length"
                                            @click="deleteSelectedMonitorList('')">
                                            清空
                                        </div>
                                    </div>

                                </div>
                                <div class="selectContentBox">
                                    <div class="flex">
                                        <div class="left left1" v-loading="loading">
                                            <el-checkbox-group v-model="checkedAccount"
                                                @change="handleCheckedCitiesChange">
                                                <div class="flex alcenter  pb20"
                                                    v-for="(item, index) in isSearching ? searchMonitorList : monitorList"
                                                    :key="index">
                                                    <el-checkbox :label="item" class="w100percent">
                                                        <div class=" flex alcenter">
                                                            <img class="productImg" :class="pageSmall ? 'mr5' : 'mr10'"
                                                                v-if="activeWayBoxIndex == 3" :src="item.img" alt="">
                                                            <div>
                                                                <div class="h20"
                                                                    :class="pageSmall ? 'overflow1_120 fs16' : 'overflow1_300 fs18'">
                                                                    {{ item.name ||
                                                                        item.productName }}</div>
                                                                <div class="c_999 "
                                                                    :class="pageSmall ? 'fs12' : ' fs14'">
                                                                    ID:{{ activeWayBoxIndex ? activeWayBoxIndex == 1 ?
                                                                        item.adId : activeWayBoxIndex == 2 ?
                                                                            item.id
                                                                            : item.id : item.advertiserId }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </el-checkbox>
                                                </div>
                                            </el-checkbox-group>
                                            <div class="pt50 nodata flex-center"
                                                v-if="isSearching ? !searchMonitorList.length : !monitorList.length">
                                                暂无数据
                                            </div>
                                        </div>
                                        <div class="left p5  " v-loading="loading">
                                            <div class="flex-between alcenter selectedAccountBox pb20 mb10"
                                                v-for="(item, index) in selectedMonitorList" :key="index">
                                                <div class="pl5 flex alcenter">
                                                    <img class="productImg " :class="pageSmall ? 'mr5' : 'mr10'"
                                                        v-if="activeWayBoxIndex == 3" :src="item.img" alt="">
                                                    <div :class="pageSmall ? '' : 'pl10'">
                                                        <div
                                                            :class="pageSmall ? 'overflow1_100 fs16' : 'overflow1_300 fs18'">
                                                            {{
                                                                item.name || item.productName
                                                            }}
                                                        </div>
                                                        <div class="c_999 "
                                                            :class="pageSmall ? ' overflow1_100 fs12' : 'overflow1_300 fs14'">
                                                            ID:{{ activeWayBoxIndex ? activeWayBoxIndex == 1 ?
                                                                item.adId : activeWayBoxIndex == 2 ? item.id
                                                                    : item.id : item.advertiserId }}
                                                        </div>
                                                    </div>

                                                </div>
                                                <i class="el-icon-error" @click="deleteSelectedMonitorList(index)"></i>
                                            </div>
                                            <div class="pt50 nodata flex-center" v-if="!selectedMonitorList.length">
                                                暂无数据
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="planFilter pt20 " v-if="activeWayBoxIndex !== 1">
                                计划维度筛选
                                <div class="flex alcenter pt10">
                                    <el-select disabled v-if="activeWayBoxIndex !== 3" v-model="planFilterValue"
                                        placeholder="请选择">
                                        <el-option key="推商品" label="推商品" value="推商品">
                                        </el-option>
                                    </el-select>
                                    <el-select disabled class="pl10" v-model="deliveryMethodValue" placeholder="请选择">
                                        <el-option v-for="item in deliveryMethodList" :key="item.value"
                                            :label="item.label" :value="item.name">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="monitorTargetBox ">
                        <div class="pb10 font-bold">计划白名单</div>
                        <div class="monitorTargetContent fs14">
                            <el-select v-model="planWhiteList" multiple filterable allow-create default-first-option
                                clearable collapse-tags class="input400 input_h35"
                                @change="planWhiteList = normalizePlanWhiteList(planWhiteList)"
                                placeholder="输入计划ID后回车确认；已加载计划会自动出现在下拉中">
                                <el-option v-for="item in planWhiteListOptions" :key="item.value"
                                    :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                            <div class="pt10 c_999">
                                命中白名单的计划不会被当前规则处理；未加载到的计划也可以直接输入计划ID。
                            </div>
                        </div>
                    </div>
                    <div class="monitorTargetBox ">
                        <div class="pb10  font-bold">执行内容</div>
                        <div class="monitorTargetContent fs14">
                            <div class="flex alcenter input100">
                                <span class="pr10 fs16">
                                    数据范围
                                </span>
                                <el-select v-model="rangeValue" placeholder="请选择数据范围">
                                    <el-option v-for="item in rangeList" :key="item" :label="item" :value="item">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="flex  pt20">
                                <span class="pr10  fs16">
                                    执行条件
                                </span>
                                <div class="">
                                    <div class=" flex flex_wrap alcenter input100">
                                        <el-select class="mb20" disabled v-model="consumeValue" placeholder="请选择">
                                            <el-option key="消耗" label="消耗" value="消耗">
                                            </el-option>
                                        </el-select>
                                        <span class="pl10 pr10 mb20">
                                            大于
                                        </span>
                                        <div class="relative mb20">
                                            <el-input type="number" v-model="consumeMoney" placeholder="请输入"
                                                suffix-icon="元" size="medium" />
                                            <div class="yuan_box">
                                                元
                                            </div>
                                        </div>
                                        <span class="pl10 pr10 mb20">
                                            且满足以下
                                        </span>
                                        <el-select class="mb20" v-model="conditionValue" placeholder="请选择">
                                            <el-option v-for="item in conditionList" :key="item" :label="item"
                                                :value="item">
                                            </el-option>
                                        </el-select>
                                        <span class="pl10 pr10 mb20">
                                            条件
                                        </span>
                                    </div>
                                    <div class="flex alcenter  flex_wrap   "
                                        v-for="(condition, index) in executeConditionList" :key="index">
                                        <el-select class=" mr10 mb20" :class="pageSmall ? 'input150' : 'input200'"
                                            @change="ordersChange" v-model="condition.ordersValue" placeholder="请选择">
                                            <el-option v-for="(item, index) in ordersList" :key="index"
                                                :label="item.name" :value="item.name" :disabled="item.disabled">
                                            </el-option>
                                        </el-select>
                                        <el-select class="input120 mr10 mb20" v-model="condition.compareValue"
                                            placeholder="请选择">
                                            <el-option v-for="item in compareList" :key="item" :label="item"
                                                :value="item">
                                            </el-option>
                                        </el-select>
                                        <el-input class="input150 w150 mb20" type="number"
                                            v-model="condition.consumeMoney" placeholder="请输入" />

                                        <i @click="goDeleteCondition(index)" class="el-icon-delete mb20 c_primary ml20"
                                            v-if="executeConditionList.length > 1"></i>
                                    </div>
                                    <div class="addCondition flex-center " v-if="executeConditionList.length < 4"
                                        @click="addCondition">
                                        + 增加条件
                                    </div>
                                </div>
                            </div>
                            <div class="flex  pt20">
                                <span class="pr10 pt10 fs16">
                                    执行动作
                                </span>
                                <div class="">
                                    <div class="flex alcenter flex_wrap ">
                                        <el-select class="mr10 input120 mb20" v-model="executeValue" placeholder="请选择">
                                            <el-option v-for="(item, index) in executeList"
                                                :disabled="index ? true : false" :key="index" :label="item"
                                                :value="item">
                                            </el-option>
                                        </el-select>
                                        <div class="pr10 flex alcenter flex_wrap  mb20" v-if="executeValue == '缓冲执行'">
                                            计时
                                            <div class="text-center"
                                                :class="{ 'pt20': !(timeInputValue % 5 === 0) || timeInputValue == 0 }">
                                                <el-input type="number" class="input75 w100" v-model="timeInputValue"
                                                    placeholder="请输入规则名称" />

                                                <div class="c_ff3939"
                                                    v-if="!(timeInputValue % 5 === 0) || timeInputValue == 0">
                                                    请输入5的倍数且不为0
                                                </div>
                                            </div>
                                            分钟，出现以下任意情况则会
                                        </div>
                                        <el-select class=" mr10 input150 mb20" v-model="noticeValue" placeholder="请选择">
                                            <el-option v-for="item in noticeList" :key="item" :label="item"
                                                :value="item">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div class="c_ffb563 mb20" v-if="executeValue == '缓冲执行'">
                                        1、{{ timeInputValue }}分钟后
                                        <div class="flex alcenter pb10">
                                            2、 消耗达到
                                            <div class="relative pl5">
                                                <el-input type="number" class="input100 w100"
                                                    v-model="consumeMoney_slow" placeholder="" suffix-icon="元"
                                                    size="medium" />
                                                <div class="yuan_box c_000">
                                                    元
                                                </div>
                                            </div>
                                        </div>
                                        <div class="c_ff3939" v-if="consumeMoney_slow < 5">
                                            请输入大于5的数值
                                        </div>
                                    </div>
                                    <div class="flex alcenter  flex_wrap">
                                        <el-switch class="mr10 " :disabled="noticeValue == '仅通知'"
                                            style="transform: scale(1.1);" v-model="isLimitNotice">
                                        </el-switch>
                                        关停后持续监控
                                        <el-input :disabled="!isLimitNotice" type="number"
                                            class="input100 w100 ml10 mr10" v-model="watchMinute" placeholder="请输入" />
                                        <div :class="pageSmall ? 'pt20' : ''">分钟，所选执行条件指标如不满足，则自动开启计划</div>
                                    </div>
                                    <div class="c_ff3939" v-if="!(watchMinute % 5 === 0) || watchMinute == 0">
                                        请输入5的倍数且不为0
                                    </div>
                                </div>
                            </div>
                            <div class="flex  pt20">
                                <span class="pr10 pt10 fs16">
                                    执行时段
                                </span>
                                <div>
                                    <div class="flex alcenter mb10">
                                        <div class="timePeriodBox" @click="activeTimePeriodBox = 0"
                                            :class="{ 'activeTimePeriodBox': !activeTimePeriodBox }">
                                            不限
                                        </div>
                                        <div class="timePeriodBox" @click="activeTimePeriodBox = 1"
                                            :class="{ 'activeTimePeriodBox': activeTimePeriodBox }">
                                            指定时段
                                        </div>
                                    </div>
                                    <div class="pt10 " v-if="activeTimePeriodBox && !pageSmall">
                                        <table border class="yl-time-range-table">
                                            <thead class="table_head">
                                                <tr>
                                                    <th colspan="24">00:00 - 12:00</th>
                                                    <th colspan="24">12:00 - 24:00</th>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" v-for="(item, index) in 24" :key="index"> {{ item -
                                                        1 }}</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr @mouseleave="handleMouseLeave">
                                                    <td colspan="1" v-for="(item, index) in 48" :key="index">
                                                        <div class="time_select_box" :class="{
                                                            'time_select_box_active': timeSelectActiveList.includes(item),
                                                            'time_select_box_inactive': !timeSelectActiveList.includes(item),
                                                            'time_select_box_active2': draggedElements.includes(item)
                                                        }" @mousedown.stop="onMouseDown(item, $event)"
                                                            @mousemove.stop="onMouseMove(item, $event)"
                                                            @mouseup.stop="onMouseUp(item)">
                                                            <div class="trigger" style="display: inline-block;">
                                                                <div class="yl-time-range-triger"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="pt10 " v-if="activeTimePeriodBox && pageSmall">
                                        <table border class="yl-time-range-table">
                                            <thead class="table_head">
                                                <tr>
                                                    <th colspan="24">00:00 - 12:00</th>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" v-for="(item, index) in 12" :key="index"> {{ item -
                                                        1 }}</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr @mouseleave="handleMouseLeave">
                                                    <td colspan="1" v-for="(item, index) in 24" :key="index">
                                                        <div class="time_select_box" :class="{
                                                            'time_select_box_active': timeSelectActiveList.includes(item),
                                                            'time_select_box_inactive': !timeSelectActiveList.includes(item),
                                                            'time_select_box_active2': draggedElements.includes(item)
                                                        }" @mousedown.stop="onMouseDown(item, $event)"
                                                            @mousemove.stop="onMouseMove(item, $event)"
                                                            @mouseup.stop="onMouseUp(item)">
                                                            <div class="trigger" style="display: inline-block;">
                                                                <div class="yl-time-range-triger"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table border class="yl-time-range-table">
                                            <thead class="table_head">
                                                <tr>
                                                    <th colspan="24">12:00 - 24:00</th>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" v-for="(item, index) in 12" :key="index"> {{ item +
                                                        11 }}</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr @mouseleave="handleMouseLeave">
                                                    <td colspan="1" v-for="(item, index) in 24" :key="index">
                                                        <div class="time_select_box" :class="{
                                                            'time_select_box_active': timeSelectActiveList.includes(item + 24),
                                                            'time_select_box_inactive': !timeSelectActiveList.includes(item + 24),
                                                            'time_select_box_active2': draggedElements.includes(item + 24)
                                                        }" @mousedown.stop="onMouseDown(item + 24, $event)"
                                                            @mousemove.stop="onMouseMove(item + 24, $event)"
                                                            @mouseup.stop="onMouseUp(item + 24)">
                                                            <div class="trigger" style="display: inline-block;">
                                                                <div class="yl-time-range-triger"></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="c_ff3939 pt10"
                                        v-if="activeTimePeriodBox && !timeSelectActiveList.length">
                                        请选择时间
                                    </div>
                                </div>
                            </div>
                            <div class="flex alcenter  pt20" v-if="noticeValue !== '仅关停'">
                                <span class="pr20 ">
                                    通知方式
                                </span>
                                <div>
                                    <el-checkbox :style="{ 'transform: scale(1.2);': !pageSmall }" v-model="wxNotice">
                                        微信通知
                                    </el-checkbox>
                                    <div v-if="!wxNotice" class="c_ff3939 pt10">
                                        请选择通知方式
                                    </div>
                                </div>
                            </div>
                            <div class="flex  pt20" v-if="wxNotice && noticeValue !== '仅关停'">
                                <span class="pr10 pt10">
                                    微信联系人
                                </span>
                                <div>
                                    <div>
                                        <el-select :class="pageSmall ? 'input200' : 'w400 input400'" multiple
                                            v-model="wxContracts" filterable placeholder="请选择联系人">
                                            <el-option v-for="item in wxContractsOptions" :key="item.wechatName"
                                                :label="item.wechatName" :value="item.openId">
                                            </el-option>
                                        </el-select>
                                        <span class="pl20 c_primary" @click="goAddContrats">添加联系人</span>
                                    </div>
                                    <div class="flex alcenter flex_wrap pt10">
                                        <el-switch class="mr10" :style="{ 'transform: scale(1.1);': !pageSmall }"
                                            v-model="isLimitWXNotice">
                                        </el-switch>
                                        限制通知频率，每条计划
                                        <el-select v-model="wxNoticeTimeValue" :disabled="!isLimitWXNotice"
                                            class="ml5 input150" placeholder="请选择" :class="pageSmall ? 'mt20' : ''">
                                            <el-option v-for="(item, index) in wxNoticeTimeList" :key="index"
                                                :label="item.name" :value="item.value">
                                            </el-option>
                                        </el-select>
                                        <div :class="pageSmall ? 'mt20' : ''">
                                            内最多通知一次
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="oe-drawer-section oe-drawer-section--bottom">
                        <span class="oe-drawer-form-label">监控状态</span>
                        <el-select class="input250" v-model="monitorStatus" placeholder="请选择">
                            <el-option v-for="item in monitorStatusList" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="oe-drawer-form-row">
                        <span class="oe-drawer-form-label">规则名称</span>
                        <el-input class="input250 w250" v-model="ruleName" placeholder="请输入规则名称" />
                    </div>
                    <div class="oe-drawer-form-row">
                        <span class="oe-drawer-form-label">请选择代理</span>
                        <el-select size="medium" v-model="selectAgentId" placeholder="请选择代理" clearable filterable>
                            <el-option v-for="(option, index) in agentList" :key="index" :label="option.username"
                                :value="option.id" />
                        </el-select>
                    </div>
                </div>
                <div class="drawer_footer flex-end alcenter">
                    <el-button class="mb-10 fs18" round type="primary" size="small" @click="closeRulePopup">
                        取消
                    </el-button>
                    <el-button class="mb-10 fs18" round type="primary" size="small" @click="goAddRule">
                        确定
                    </el-button>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";
import GuidePanel from "@/components/GuidePanel/GuidePanel";
import {
    buildMonitorObjectInfo,
    buildPlanWhiteListOptions,
    normalizePlanWhiteList,
    parseMonitorObjectInfo,
} from "@/utils/smartRoiRuleFormHelper";
// import request from "@/utils/axios";
// import message from "@/utils/message";

export default {
    name: 'ShutDownDueToOverallLosses',
    components: { CommonTable, GuidePanel },
    data() {
        return {
            agentList: [],
            selectAgentId: '',
            editData: {},
            activeWayBoxIndex: 0,
            accountPlanType: '推商品',
            launchValue: '控成本投放',
            launchList: ['控成本投放', '放量投放'],
            selectedAccount: '',
            selectedDYNumber: '',
            loading: false,
            isSearching: false,
            startTime: '',
            endTime: '',
            monitorAdvertiserId: '',

            searchKeyWord: '',
            searchMonitorList: [],
            monitorWayList: [
                {
                    wayName: '账户',
                    info: '监控账户下所有计划'
                },
                {
                    wayName: '计划',
                    info: '监控指定计划'
                },
                {
                    wayName: '抖音号',
                    info: '监控抖音号下的计划'
                },
                {
                    wayName: '商品',
                    info: '监控指定商品下的计划'
                },
            ],
            // 监控目标
            checkAll: false,
            checkedAccount: [],
            accountList: [],
            planList: [],
            monitorList: [],
            dyNumberList: [],
            selectData: '',
            pickerOptions: {
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setHours(0, 0, 0, 0);  // 今天00:00:00
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                        const end = new Date();
                        end.setDate(end.getDate() - 1);
                        end.setHours(23, 59, 59, 999);  // 昨天23:59:59.999
                        const start = new Date(end);
                        start.setHours(0, 0, 0, 0);  // 昨天00:00:00
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '近3天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setDate(start.getDate() - 2);  // 3天前（含今天）
                        start.setHours(0, 0, 0, 0);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '近7天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setDate(start.getDate() - 6);  // 7天前（含今天）
                        start.setHours(0, 0, 0, 0);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '近15天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setDate(start.getDate() - 14);  // 15天前（含今天）
                        start.setHours(0, 0, 0, 0);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '近30天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setDate(start.getDate() - 29);  // 30天前（含今天）
                        start.setHours(0, 0, 0, 0);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '上周',
                    onClick(picker) {
                        const today = new Date();
                        const day = today.getDay(); // 本周的第几天（0=周日）
                        const diff = day === 0 ? 6 : day - 1; // 到上周一的天数差

                        const end = new Date(today);
                        end.setDate(today.getDate() - diff - 1); // 上周日
                        end.setHours(23, 59, 59, 999);

                        const start = new Date(end);
                        start.setDate(end.getDate() - 6); // 上周一
                        start.setHours(0, 0, 0, 0);

                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '本月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setDate(1);  // 本月1号
                        start.setHours(0, 0, 0, 0);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '上月',
                    onClick(picker) {
                        const end = new Date();
                        end.setMonth(end.getMonth(), 0);  // 上月最后一天
                        end.setHours(23, 59, 59, 999);

                        const start = new Date(end);
                        start.setDate(1);  // 上月1号
                        start.setHours(0, 0, 0, 0);

                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            selectedMonitorList: [],
            planWhiteList: [],
            planWhiteListOptions: [],
            planFilterValue: '推商品',
            deliveryMethodValue: '控成本投放',
            deliveryMethodList: [{
                name: '投放方式：不限',
            }, {
                name: '控成本投放',
            }, {
                name: '放量投放',
            },],
            rangeValue: '当日',
            consumeValue: '消耗',
            rangeList: ['当日', '最近2天', '最近3天', '最近4天', '最近5天', '最近6天', '最近7天'],
            conditionValue: '所有',
            compareList: ['小于等于', '大于'],
            ordersList: [{
                name: '消耗',
                disabled: true
            }, {
                name: '整体成交订单数',
                disabled: true
            }, {
                name: '整体成交金额',
                disabled: false
            }, {
                name: '整体支付ROI',
                disabled: false
            }, {
                name: '整体成交订单成本',
                disabled: false
            },],
            conditionList: ['任一', '所有'],
            executeConditionList: [{
                ordersValue: '整体成交订单数',
                compareValue: '小于等于',
                consumeMoney: '',
            }],
            consumeMoney: '',
            consumeMoney_slow: '',

            // 执行动作
            executeValue: '立即执行',
            executeList: ['立即执行', '缓冲执行'],
            timeInputValue: 5,
            noticeValue: '仅通知',
            noticeList: ['仅通知', '仅关停', '关停且通知'],
            isLimitNotice: false,
            watchMinute: 5,

            // 执行时段
            activeTimePeriodBox: 0,
            timeSelectActiveList: [],

            // 通知方式
            wxNotice: true,
            wxContracts: [],
            wxContractsOptions: [],
            isLimitWXNotice: false,
            wxNoticeTimeValue: 30,
            wxNoticeTimeList: [{
                name: '每30分钟',
                value: 30
            }, {
                name: '每1小时',
                value: 60
            }, {
                name: '每3小时',
                value: 180
            }, {
                name: '每6小时',
                value: 360
            }],

            // 监控状态
            monitorStatus: '启用',
            monitorStatusList: ['启用', '停用'],

            // 规则名称
            ruleName: '',
            isIndeterminate: true,
            showAddCreateRulePopup: false,
            selectIds: [],
            searchs: [{
                name: 'monitorStatus',
                placeholder: '监控状态',
                type: 'select',
                select: true,
                // selectUrl: '/oceanEngineAdvertiser/getAllInfo',
                selectData: [],
                selectValue: [{
                    value: '关闭',
                    key: 0
                }, {
                    value: '开启',
                    key: 1
                }]
            }, {
                name: 'createPerson',
                placeholder: '创建人',
                type: 'select',
                select: true,
                selectUrl: '/agent/getAll',
                selectData: [],
            },
            //  {
            //     name: 'aweMeId',
            //     placeholder: '通知人',
            //     type: 'select',
            //     select: true,
            //     // selectUrl: '/oceanEngineAdvertiser/getAllInfoAndDouYin',
            //     selectData: [],
            // },
            {
                name: 'ruleName',
                placeholder: '规则名称',
                type: 'input'
            }],
            permission: {
                add: 'launchTheProduct:add',
                update: 'launchTheProduct:update',
                delete: 'launchTheProduct:delete',
                deleteBatch: 'launchTheProduct:deleteBatch'
            },
            url: {
                get: '/smartRoiRules/listByCondition?intelligentRegulationType=0',
                // add: '/launchTheProduct/add',
                // update: '/launchTheProduct/update',
                // delete: '/launchTheProduct/delete',
                // delete_batch: '/launchTheProduct/deleteBatch',
                // status: '/launchTheProduct/status',
            },
            tableColumns: [{
                field: 'status',  // 字段名
                label: '状态',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
                status: true,  // 是否展示
            }, {
                field: 'ruleName',  // 字段名
                label: '规则名称',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
            }, {
                field: 'accountNum',  // 字段名
                label: '监控方式',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
                tableType: 'monitorMode'
            }, {
                field: 'monitorList',  // 字段名
                label: '监控对象',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
                tableType: 'monitorList'
            }, {
                field: 'ruleInfo',  // 字段名
                label: '规则详情',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
                width: 600
            }, {
                field: 'executionMethod',  // 字段名
                label: '执行方式',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
            }, {
                field: 'executeAction',  // 字段名
                label: '执行动作',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
            }, {
                field: 'createPerson',  // 字段名
                label: '创建人',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,
            }
            ],
            formFields: {
                addTitle: '添加',
                updateTitle: '修改',
                model: [
                    {
                        field: 'id',  // 字段名
                        label: 'ID',  // 字段显示名称
                        type: 'input',
                        add: false,  // 是否添加
                        update: true
                    },
                    {
                        field: 'agentId',  // 字段名
                        label: 'agentId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入agentId',
                        rules: [
                            { required: true, message: 'agentId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'userId',  // 字段名
                        label: 'userId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入userId',
                        rules: [
                            { required: true, message: 'userId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'advertiserId',  // 字段名
                        label: 'advertiserId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入advertiserId',
                        rules: [
                            { required: true, message: 'advertiserId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'aweMeId',  // 字段名
                        label: 'aweMeId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入aweMeId',
                        rules: [
                            { required: true, message: 'aweMeId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'productId',  // 字段名
                        label: 'productId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入productId',
                        rules: [
                            { required: true, message: 'productId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'productName',  // 字段名
                        label: 'productName',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入productName',
                        rules: [
                            { required: true, message: 'productName不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'img',  // 字段名
                        label: 'img',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入img',
                        rules: [
                            { required: true, message: 'img不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'tag',  // 字段名
                        label: 'tag',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入tag',
                        rules: [
                            { required: true, message: 'tag不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'categoryName',  // 字段名
                        label: 'categoryName',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入categoryName',
                        rules: [
                            { required: true, message: 'categoryName不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'sellNum',  // 字段名
                        label: 'sellNum',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入sellNum',
                        rules: [
                            { required: true, message: 'sellNum不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'grayReason',  // 字段名
                        label: 'grayReason',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入grayReason',
                        rules: [
                            { required: true, message: 'grayReason不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'squareImageList',  // 字段名
                        label: 'squareImageList',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入squareImageList',
                        rules: [
                            { required: true, message: 'squareImageList不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'channelId',  // 字段名
                        label: 'channelId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入channelId',
                        rules: [
                            { required: true, message: 'channelId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'channelType',  // 字段名
                        label: 'channelType',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入channelType',
                        rules: [
                            { required: true, message: 'channelType不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    },
                ]
            },
            operate: [{
                icon: 'el-icon-edit',
                type: 'text',
                text: '编辑',
                handle: (row) => {
                    console.log(row)
                    this.showAddCreateRulePopup = true
                    this.editData.id = row.id
                    this.editData.monitoringTime = row.executeContent.monitoringTime
                    console.log(this.selectedMonitorList)
                    this.activeWayBoxIndex = row.monitorType - 1
                    if (!this.activeWayBoxIndex) {
                        this.monitorList = this.accountList
                        let arr = []
                        this.accountList.forEach((obj) => {
                            if (row.monitorObject.includes(obj.advertiserId)) {
                                arr.push(obj)
                            }
                        })
                        if (arr.length) {
                            this.checkedAccount = arr
                            this.handleCheckedCitiesChange(arr)
                        }
                        if (row.executeContent.monitorObjectInfo) {
                            const { planWhiteList } = parseMonitorObjectInfo(row.executeContent.monitorObjectInfo)
                            this.planWhiteList = normalizePlanWhiteList(planWhiteList)
                            this.mergePlanWhiteListOptions(
                                this.planWhiteList.map(value => ({ adId: value, name: value }))
                            )
                        }
                    } else {
                        if (row.monitorAdvertiserId) {
                            this.monitorAdvertiserId = row.monitorAdvertiserId
                            if (this.accountList.length) {
                                this.selectedAccount = JSON.parse(this.monitorAdvertiserId)
                            }
                            if (row.executeContent.monitorObjectInfo) {
                                this.restoreMonitorObjectInfo(row.executeContent.monitorObjectInfo)
                            }
                            this.monitorList = []
                            if (this.activeWayBoxIndex == 1) {
                                this.getDataByAccount(0)
                            } else if (this.activeWayBoxIndex == 2) {
                                this.getDataByAccount(1)
                            }

                        }
                        // console.log('11111111', this.activeWayBoxIndex, this.selectedAccount)
                    }
                    this.monitorStatus = row.status ? '启用' : '停用'
                    // this.activeWayBoxIndex = JSON.parse(row.monitorType) - 1
                    this.rangeValue = row.executeContent.rangeValue
                    this.consumeMoney = row.executeContent.maxConsume
                    this.conditionValue = row.executeContent.conditionValue
                    this.executeConditionList = row.executeContent.conditionList
                    this.executeValue = row.executeContent.executeValue
                    if (this.executeValue == '缓冲执行') {
                        this.timeInputValue = row.executeContent.timeInputValue
                        this.consumeMoney_slow = row.executeContent.consumeMoney_slow
                    }
                    this.noticeValue = row.executeContent.noticeValue
                    if (row.executeContent.monitorToOpen) {
                        this.isLimitNotice = true
                        this.watchMinute = row.executeContent.monitorToOpen
                    }
                    if (row.executeContent.timeSelectActiveList.length) {
                        this.activeTimePeriodBox = 1
                        this.timeSelectActiveList = row.executeContent.timeSelectActiveList
                    }
                    if (row.noticeConfig.interval) {
                        this.isLimitWXNotice = true
                        this.wxNoticeTimeValue = row.noticeConfig.interval
                    }

                    this.ruleName = row.ruleName
                    this.selectAgentId = row.userId
                    this.wxContracts = []
                    if (row.noticeConfig && row.noticeConfig.wxNumber) {
                        row.noticeConfig.wxNumber.forEach((number) => {
                            if (number !== null && number !== '') {
                                this.wxContracts.push(number)
                            }
                        })
                    }
                    if (row.noticeConfig && row.noticeConfig.interval) {
                        this.isLimitWXNotice = true
                        this.wxNoticeTimeValue = row.noticeConfig.interval
                    }
                }
            }, {
                icon: 'el-icon-edit',
                type: 'text',
                text: '删除',
                handle: (row) => {
                    console.log(row)
                    this.$axios.post({
                        url: 'smartRoiRules/delete/' + row.id,
                        success: (res) => {
                            // this.loading = false
                            console.log('333', res)
                            if (res.code == 0) {
                                this.$message.success('删除成功')
                                // this.showAddCreateRulePopup = false
                                this.$refs.table.getData()
                            } else {
                                // this.$message.error(res.msg || '出错了')

                            }
                        },
                        error: () => {
                            this.loading = false
                            this.$message.error('出错了')
                        },
                    })
                    // this.resetPwdForm.id = row.id;
                    // this.resetPwdForm.username = row.username;
                    // this.resetPwdVisible = true;
                }
            }, {
                icon: 'el-icon-tickets',
                type: 'text',
                text: '日志',
                handle: (row) => {
                    console.log(row)
                    this.$router.push({
                        path: '/qdd/admin/SmartRoiRuleLogs.html',
                        query: { id: row.id, getLog: true }
                    })
                }
            }],
            buttons: [
                {

                }
            ],
            // 元素拖拽
            draggedElements: [],
            isDragging: false,
            startX: 0,
            startY: 0,
            dragThreshold: 2,
            isMouseDown: false,
            pageSmall: false,
        }
    },
    mounted() {
        this.getADAccountList()
        this.getWxcontractsList()
        this.getAgentList()
    },
    beforeDestroy() {
        // window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        normalizePlanWhiteList,
        getAgentList() {
            this.$axios.post({
                url: '/agent/getAll',
                success: (res) => {
                    this.loading = false
                    console.log('333', res)
                    if (res.code == 0) {
                        this.agentList = res.data
                        console.log('333', this.agentList)

                    } else {
                        this.$message.error(res.msg || '出错了')

                    }
                    //
                },
                error: () => {
                    this.loading = false
                    this.$message.error('出错了')
                },
            })
        },
        goAddContrats() {
            this.showAddCreateRulePopup = false
            setTimeout(() => {
                this.$router.push({
                    path: '/qdd/admin/contacts.html',
                })
            }, 1)
        },
        isPageSmall(data) {
            this.pageSmall = data;
            console.log(this.pageSmall)
        },
        mergePlanWhiteListOptions(list = []) {
            const nextOptions = buildPlanWhiteListOptions(list)
            if (!nextOptions.length) {
                return
            }
            const optionMap = new Map(this.planWhiteListOptions.map(item => [item.value, item]))
            nextOptions.forEach((item) => {
                optionMap.set(item.value, item)
            })
            this.planWhiteListOptions = Array.from(optionMap.values())
        },
        restoreMonitorObjectInfo(raw) {
            const { selectedMonitorList, planWhiteList } = parseMonitorObjectInfo(raw)
            this.selectedMonitorList = selectedMonitorList
            this.planWhiteList = normalizePlanWhiteList(planWhiteList)
            this.mergePlanWhiteListOptions(
                this.planWhiteList.map(value => ({ adId: value, name: value }))
            )
        },
        getWxcontractsList() {
            this.$axios.post({
                url: '/wechatUser/getAll',
                success: (res) => {
                    // this.loading = false
                    console.log('333', res)
                    if (res.code == 0) {
                        this.wxContractsOptions = res.data
                    } else {
                        this.$message.error(res.msg || '出错了')
                    }
                },
                error: () => {
                    this.loading = false
                    this.$message.error('出错了')
                },
            })
        },
        onMouseDown(item, e) {
            this.isMouseDown = true;
            this.startX = e.clientX;
            this.startY = e.clientY;
            this.draggedElements = [item];
            console.log(this.startX, this.startY)
        },
        handleGlobalMouseMove(e) {
            console.log('handleGlobalMouseMove')
            if (!this.isMouseDown) return;
            const dx = Math.abs(e.clientX - this.startX);
            const dy = Math.abs(e.clientY - this.startY);
            console.log(dx, dy, 'handleGlobalMouseMove')

            if (dx >= this.dragThreshold || dy >= this.dragThreshold) {
                this.isDragging = true;
            }
        },
        onMouseMove(item, e) {
            if (!this.isMouseDown) return
            if (!this.isDragging) {
                console.log(item, e)
                // 计算移动距离
                const dx = Math.abs(e.clientX - this.startX);
                const dy = Math.abs(e.clientY - this.startY);
                console.log(dx, dy, 'handleGlobalMouseMove')

                // 超过阈值则标记为拖拽
                if (dx >= this.dragThreshold || dy >= this.dragThreshold) {
                    this.isDragging = true;
                }
            }
            if (this.isDragging && !this.draggedElements.includes(item)) {
                this.draggedElements.push(item);
                if (this.draggedElements.length >= 2) {
                    // 获取当前首尾元素
                    const first = this.draggedElements[0];
                    const last = this.draggedElements[this.draggedElements.length - 1];

                    // 计算范围的起始和结束（取最小和最大值，兼容正序/倒序拖拽）
                    const start = Math.min(first, last);
                    const end = Math.max(first, last);

                    // 填充范围内所有缺失的元素
                    for (let i = start; i <= end; i++) {
                        if (!this.draggedElements.includes(i)) {
                            this.draggedElements.push(i);
                        }
                    }
                }
            }
        },

        onMouseUp(item) {
            if (this.isDragging) {
                this.handleDragEnd();
            } else {
                this.handleClick(item);
            }

            // 重置状态
            this.isDragging = false;
            this.isMouseDown = false;
            this.draggedElements = [];
        },

        handleMouseLeave() {
            // console.log('handleMouseLeave------------')
            if (this.isDragging) {
                this.handleDragEnd();
                // 重置状态
                this.isDragging = false;
                this.isMouseDown = false;
                this.draggedElements = [];
            }
        },

        handleDragEnd() {
            // 去重并排序拖拽经过的元素

            const uniqueElements = [...new Set(this.draggedElements)].sort((a, b) => a - b);

            // 判断是否需要选中还是取消选中（全选则取消，否则选中）
            const allSelected = uniqueElements.every(el => this.timeSelectActiveList.includes(el));

            // console.log(allSelected, 'allSelected')
            if (allSelected) {
                // 取消选中：从活跃列表中移除拖拽元素
                this.timeSelectActiveList = this.timeSelectActiveList.filter(
                    el => !uniqueElements.includes(el)
                );
            } else {
                // 选中：添加拖拽元素（去重）
                uniqueElements.forEach(el => {
                    if (!this.timeSelectActiveList.includes(el)) {
                        this.timeSelectActiveList.push(el);
                    }
                });
            }

            // 最终排序
            this.timeSelectActiveList.sort((a, b) => a - b);
            console.log(this.timeSelectActiveList)
        },

        handleClick(item) {
            const index = this.timeSelectActiveList.indexOf(item);
            if (index === -1) {
                this.timeSelectActiveList.push(item);
            } else {
                this.timeSelectActiveList.splice(index, 1);
            }
            this.timeSelectActiveList.sort((a, b) => a - b);
        },
        ordersChange() {
            // console.log(this.executeConditionList)
            let list = []
            this.executeConditionList.forEach((obj) => {
                list.push(obj.ordersValue)
            })
            console.log(this.executeConditionList)
            this.ordersList.forEach((obj) => {
                if (list.includes(obj.name)) {
                    obj.disabled = true
                    // this.$set(this.ordersList)
                } else {
                    if (obj.name == '消耗') return
                    obj.disabled = false
                }
            })
        },
        // 处理选择时间
        pickData(e) {
            console.log(e)
            if (e) {
                console.log(e, '233')
                console.log(this.selectData, '233')
                const year_start = e[0].getFullYear()
                const month_start = String(e[0].getMonth() + 1).padStart(2, '0')
                const day_start = String(e[0].getDate()).padStart(2, '0')
                this.startTime = `${year_start}-${month_start}-${day_start}`
                const inputDate = new Date(e[1])
                this.endTime = this.processDate(inputDate)
                console.log(this.startTime, this.endTime, '233')
            } else {
                this.startTime = ''
                this.endTime = ''
                console.log(this.startTime, this.endTime, '233')
            }
            if (this.selectedAccount) {
                this.getPlanList()
            }
        },
        processDate(targetDate) {
            const now = new Date();
            // 创建目标日期的纯日期部分（去除时间）
            const targetDateOnly = new Date(
                targetDate.getFullYear(),
                targetDate.getMonth(),
                targetDate.getDate()
            );

            // 创建当前日期的纯日期部分（去除时间）
            const todayOnly = new Date(
                now.getFullYear(),
                now.getMonth(),
                now.getDate()
            );

            console.log(targetDateOnly.getTime() === todayOnly.getTime(), now, '555555')
            if (targetDateOnly.getTime() === todayOnly.getTime()) {
                // 如果是今天：返回当前完整时间（年月日时分秒）

                const year = now.getFullYear()
                const month = String(now.getMonth() + 1).padStart(2, '0')
                const day = String(now.getDate()).padStart(2, '0')
                // const hours = String(now.getHours()).padStart(2, '0')
                // const minutes = String(now.getMinutes()).padStart(2, '0')
                // const seconds = String(now.getSeconds()).padStart(2, '0')
                return `${year}-${month}-${day}`
            } else {
                const year_end = targetDate.getFullYear()
                const month_end = String(targetDate.getMonth() + 1).padStart(2, '0')
                const day_end = String(targetDate.getDate()).padStart(2, '0')
                return `${year_end}-${month_end}-${day_end}`
            }
        },
        closeRulePopup() {
            this.editData = {}
            this.activeWayBoxIndex = ''
            this.selectedAccount = ''
            this.selectedDYNumber = ''
            this.planWhiteList = []
            this.planWhiteListOptions = []
            this.loading = false
            this.isSearching = false
            this.startTime = ''
            this.endTime = ''
            this.searchKeyWord = ''
            this.selectedMonitorList = []
            this.checkAll = false
            this.checkedAccount = []
            this.selectData = ''
            this.searchMonitorList = []
            this.rangeValue = '当日'
            this.conditionValue = '所有'
            this.consumeMoney = ''
            this.consumeMoney_slow = ''
            this.executeValue = '立即执行'
            this.timeInputValue = 5
            this.noticeValue = '仅通知'
            this.isLimitNotice = false
            this.isIndeterminate = true
            this.watchMinute = 5
            this.activeTimePeriodBox = 0
            this.timeSelectActiveList = []
            this.monitorList = this.accountList
            this.wxContracts = []
            this.wxNotice = true
            this.isLimitWXNotice = false
            this.wxNoticeTimeValue = 30
            this.ruleName = ''
            this.selectAgentId = ''

            this.monitorStatus = '启用'

            this.showAddCreateRulePopup = false
            this.executeConditionList = [{
                ordersValue: '整体成交订单数',
                compareValue: '小于等于',
                consumeMoney: '',
            }]
        },
        goAddRule() {
            if (!this.selectedMonitorList.length) {
                let name = this.activeWayBoxIndex ? this.activeWayBoxIndex == 1 ? '计划'
                    :
                    this.activeWayBoxIndex == 2 ? '抖音号' : '商品' : '账户'
                this.$message.error('请选择广告' + name)
                return
            }

            if (this.consumeMoney == '') {
                this.$message.error('请完善执行条件')
                return
            }


            if (this.consumeMoney == 0) {
                this.$message.error('消耗需大于0')
                return
            }
            let index = this.executeConditionList.findIndex((obj) => obj.consumeMoney == '')
            if (index !== -1) {
                this.$message.error('请完善执行条件')
                return

            }

            if (this.executeValue == '缓冲执行') {
                if (this.timeInputValue == 0) {
                    this.$message.error('缓冲执行执行时间需大于0')
                    return
                }
                if (this.consumeMoney_slow == 0) {
                    this.$message.error('缓冲执行消耗需大于0')
                    return
                }
            }


            if (this.isLimitNotice) {
                if (!this.watchMinute) {
                    this.$message.error('请完善执行动作')
                    return
                }
            }


            if (!(this.watchMinute % 5 === 0) || this.watchMinute == 0) {
                this.$message.error(' 请输入5的倍数且不为0')
                return
            }

            if (this.activeTimePeriodBox) {
                if (!this.timeSelectActiveList.length) {
                    this.$message.error('请选择时间')
                    return
                }
            }
            if (this.noticeValue !== '仅关停') {
                if (!this.wxNotice) {
                    this.$message.error('请选择通知方式')
                    return
                }

            }
            if (!this.wxContracts.length) {
                this.$message.error('请选择联系人')
                return
            }

            if (!this.ruleName) {
                this.$message.error('请输入规则名称')
                return
            }

            if (!this.selectAgentId) {
                this.$message.error('请选择代理')
                return
            }

            let ids = []
            this.selectedMonitorList.forEach((obj) => {
                if (!this.activeWayBoxIndex) {
                    ids.push(obj.advertiserId)
                } else if (this.activeWayBoxIndex == 1) {
                    ids.push(obj.adId)
                } else if (this.activeWayBoxIndex == 2) {
                    ids.push(obj.id)
                } else if (this.activeWayBoxIndex == 3) {
                    ids.push(obj.id)
                }
            })


            let noticeConfig = {  //通知设置，如通知设置传0则为不通知
                wxNumber: this.wxContracts,  //通知微信号
                interval: this.isLimitWXNotice ? this.wxNoticeTimeValue : 0  //限制的通知频率，为0则不限制
            }
            let executeContent = {
                rangeValue: this.rangeValue,  //数据范围    ['当日', '最近2天', '最近3天', '最近4天', '最近5天', '最近6天', '最近7天']
                consumeValue: this.consumeValue, // 写死 消耗
                maxConsume: this.consumeMoney,   //消耗大于多少元
                conditionValue: this.conditionValue, //满足所以或任一   ['所有', '任一']
                conditionList: this.executeConditionList,  //条件list     [{ ordersValue: '整体成交订单数',  compareValue: '小于等于',consumeMoney: '', }],
                //ordersValue 值有  ['消耗','整体成交订单数','整体成交金额','整体支付ROI', '整体成交订单成本']
                //compareValue 值有   ['小于等于', '大于']
                //consumeMoney 是消耗金额
                executeValue: this.executeValue, //执行速度   ['立即执行', '缓冲执行']
                noticeValue: this.noticeValue, //动作是否通知  ['仅通知', '仅关停', '关停且通知'],
                timeInputValue: this.executeValue == '缓冲执行' ? this.timeInputValue : 0,  //缓冲执行后计时多少分钟，传0为立即执行
                consumeMoney_slow: this.executeValue == '缓冲执行' ? this.consumeMoney_slow : 0, //缓冲执行后消耗达到多少元 ，传0为立即执行
                monitorToOpen: this.isLimitNotice ? this.watchMinute : 0, //关停后持续监测多少分钟，传0为不检测
                timeSelectActiveList: this.activeTimePeriodBox ? this.timeSelectActiveList : [0], //执行时段 不限传0，否则传数组，值为0-48 各代表半小时
                monitoringTime,
                monitorObjectInfo: buildMonitorObjectInfo(this.selectedMonitorList, this.planWhiteList),
            }
            console.log(executeContent)
            const now = new Date();
            const year = now.getFullYear()
            const month = String(now.getMonth() + 1).padStart(2, '0')
            const day = String(now.getDate()).padStart(2, '0')
            const hours = String(now.getHours()).padStart(2, '0')
            const minutes = String(now.getMinutes()).padStart(2, '0')
            const seconds = String(now.getSeconds()).padStart(2, '0')
            let monitoringTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`


            if (this.editData.monitoringTime) {
                executeContent.monitoringTime = this.editData.monitoringTime
            } else {
                executeContent.monitoringTime = monitoringTime
            }
            let data = {
                userId: this.selectAgentId,
                ruleName: this.ruleName,
                marketingTarget: 0,
                monitorType: this.activeWayBoxIndex + 1,
                status: 1,
                monitorObject: ids,
                planWhitelist: JSON.stringify(this.planWhiteList),
                executeContent: JSON.stringify(executeContent),
                noticeConfig: JSON.stringify(noticeConfig),
                intelligentRegulationType: 0,
                monitorAdvertiserId: this.selectedAccount,
            }
            console.log(data)

            let url
            if (this.editData.id) {
                data.id = this.editData.id
                url = 'smartRoiRules/update'
            } else {
                url = 'smartRoiRules/add'
            }
            this.$axios.post({
                url,
                data,
                success: (res) => {
                    // this.loading = false
                    console.log('333', res)
                    if (res.code == 0) {
                        this.closeRulePopup()
                        this.$refs.table.getData()
                    } else {
                        this.$message.error(res.msg || '出错了')

                    }
                },
                error: () => {
                    this.loading = false
                    this.$message.error('出错了')
                },
            })


        },
        handleCheckAllChange(e) {
            console.log(e)
            this.checkedAccount = e ? this.monitorList : []
            this.selectedMonitorList = this.checkedAccount
            this.isIndeterminate = false
            console.log(this.isIndeterminate, 'this.isIndeterminate')
        },
        handleCheckedCitiesChange(e) {
            // console.log(e)
            this.selectedMonitorList = e
            this.checkAll = e.length === this.monitorList.length
            this.isIndeterminate = e.length > 0 && e.length < this.monitorList.length
        },
        deleteSelectedMonitorList(index) {
            console.log(index, 'index')
            if (index === '') {
                console.log('handleCheckAllChange')
                this.handleCheckAllChange(false)
            } else {
                this.checkedAccount = this.checkedAccount.slice(0, index).concat(this.checkedAccount.slice(index + 1));
                this.selectedMonitorList = this.checkedAccount
            }
            this.checkAll = false
        },
        addCondition() {
            this.ordersChange()
            let index = this.ordersList.findIndex((obj) => !obj.disabled)
            this.executeConditionList.push({
                ordersValue: this.ordersList[index].name,
                compareValue: '小于等于',
                consumeMoney: '',
            })
        },
        goDeleteCondition(index) {
            this.executeConditionList.splice(index, 1)
        },
        goSelectMonitorWay(index) {
            this.activeWayBoxIndex = index
            this.monitorList = []
            this.selectedMonitorList = []
            this.selectedAccount = ''
            this.searchKeyWord = ''
            this.isSearching = false
            this.searchMonitorList = []
            this.checkedAccount = []
            this.checkAll = false
            this.planWhiteList = []
            this.planWhiteListOptions = []

            if (!this.activeWayBoxIndex) {
                this.getADAccountList()

            }
        },

        goSearchMonitorList(type) {
            if (!this.searchKeyWord) return
            this.isSearching = true
            this.searchMonitorList = []
            if (!type) {
                this.monitorList.forEach((obj) => {
                    if (obj.name.includes(this.searchKeyWord) || JSON.stringify(obj.advertiserId).includes(this.searchKeyWord)) {
                        this.searchMonitorList.push(obj)
                    }
                })
            } else if (type == 1) {
                this.monitorList.forEach((obj) => {
                    if (obj.name.includes(this.searchKeyWord) || JSON.stringify(obj.adId).includes(this.searchKeyWord)) {
                        this.searchMonitorList.push(obj)
                    }
                })
            } else if (type == 2) {
                this.monitorList.forEach((obj) => {
                    if (obj.name.includes(this.searchKeyWord) || JSON.stringify(obj.id).includes(this.searchKeyWord)) {
                        this.searchMonitorList.push(obj)
                    }
                })
            } else if (type == 3) {
                this.monitorList.forEach((obj) => {
                    if (obj.name.includes(this.searchKeyWord) || JSON.stringify(obj.id).includes(this.searchKeyWord)) {
                        this.searchMonitorList.push(obj)
                    }
                })
            }
            console.log(this.searchMonitorList)

        },
        returnId(data) {
            this.selectIds = data;
            console.log(this.selectIds)
        },
        addCreateRule() {
            this.showAddCreateRulePopup = true;
        },
        getADAccountList() {
            this.$axios.post({
                url: '/oceanEngineAdvertiser/getAllInfo',
                success: (res) => {
                    console.log('333', res)
                    this.accountList = res.data
                    this.monitorList = this.accountList
                    if (this.monitorAdvertiserId) {
                        this.selectedAccount = JSON.parse(this.monitorAdvertiserId)
                    }
                },
                error: () => {
                    this.$message.error('出错了')
                },
            })
        },
        getDataByAccount(type) {
            if (type) {
                this.getdyNumberList()

            } else {
                this.getPlanList()
            }

        },
        getPlanList() {
            this.monitorList = []
            this.loading = true
            let data = {
                advertiserId: this.selectedAccount,
                smart_bid_type: this.launchValue == '控成本投放' ? 'SMART_BID_CUSTOM' : 'SMART_BID_CONSERVATIVE',
                pageIndex: 1,
                pageSize: 100
            }
            if (this.endTime) {
                data.create_start_date = this.startTime
            }
            if (this.startTime) {
                data.create_end_date = this.endTime
            }
            console.log(data, 'data------')
            this.$axios.post({
                url: 'uniPromotion/listByCondition',
                data,
                success: (res) => {
                    this.loading = false
                    console.log('333', res)
                    if (res.code == 0) {
                        this.planList = res.data.content
                        this.monitorList = this.planList
                        this.mergePlanWhiteListOptions(this.planList)
                        if (this.selectedMonitorList.length && this.activeWayBoxIndex == 1) {
                            let arr = []
                            this.selectedMonitorList.forEach((obj) => {
                                let adIndex = this.planList.findIndex((ad) => ad.adId == obj.adId)
                                if (adIndex !== -1) {
                                    arr.push(this.planList[adIndex])
                                }
                            })
                            this.checkedAccount = arr
                            this.handleCheckedCitiesChange(arr)
                        }
                    } else {
                        this.$message.error(res.msg || '出错了')

                    }

                    //
                },
                error: () => {
                    this.loading = false
                    this.$message.error('出错了')
                },
            })
        },
        getProductList(type) {
            this.checkAll = false
            this.selectedMonitorList = []
            this.searchKeyWord = ''
            this.isSearching = false
            this.searchMonitorList = []
            this.monitorList = []
            this.loading = true
            console.log(this.selectedAccount, this.selectedDYNumber)
            let object = {
                advertiserId: this.selectedAccount,
                aweMeId: this.selectedDYNumber,
                isAll: true,
                // pageIndex: this.pageIndex,
            }
            console.log(object)
            this.$axios.post({
                url: '/launchTheProduct/getProductList',
                data: object,
                success: (res) => {
                    this.loading = false
                    console.log(res);
                    if (res.code === 0) {
                        console.log(res)
                        this.monitorList = res.data.productList
                        console.log(this.monitorList)
                        if (type) {
                            this.getdyNumberList(1)
                        }
                    } else {
                        this.$message.error(res.msg)
                        this.loading = false
                    }
                }
            })

        },
        getdyNumberList(type) {
            if (!type) {
                this.monitorList = []
            }
            this.loading = true
            this.$axios.get({
                url: '/oceanEngineAdvertiser/getAllInfoAndDouYin/' + this.selectedAccount,
                success: (res) => {
                    console.log(res, '222')
                    this.loading = false
                    if (res.code === 0) {
                        this.dyNumberList = res.data
                        if (type) return
                        this.monitorList = res.data
                        if (this.selectedMonitorList.length && this.activeWayBoxIndex == 2) {
                            let arr = []
                            this.selectedMonitorList.forEach((obj) => {
                                let adIndex = this.dyNumberList.findIndex((ad) => ad.id == obj.id)
                                if (adIndex !== -1) {
                                    arr.push(this.dyNumberList[adIndex])
                                }
                            })
                            this.checkedAccount = arr
                            this.handleCheckedCitiesChange(arr)
                        }
                    } else {
                        this.$message.error(res.msg || '获取数据错误')
                    }
                },
                error: () => {
                    this.loading = false
                    this.$message.error('出错了')
                },
            })
        },

        //重置表单
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },

    }
}
</script>

<style scoped>
@import "../../styles/ocean-engine-rule-drawer.css";

* {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
}

.createRuleTitle {
    font-weight: 600;
}

.createRuleTitle i {
    cursor: pointer;
}

.monitorWayBox,
.monitorTargetBox {
    padding: 14px 20px;
}

.monitorWayBox .way_box {
    font-size: 14px;
    cursor: pointer;
    width: 220px;
    /* height: 80px; */
    padding: 20px 0;
    border: 1px solid #ddd;
    color: #333;
    border-radius: 5px;
}

.monitorWayBox .way_info {
    color: #666;
}

.active_way_box {
    border-color: #346bf6 !important;
    color: #346bf6 !important;
}

.monitorTargetBox .monitorTargetContent {
    background-color: #f9f9f9;
    border-radius: 5px;
    padding: 15px;
}


/deep/ .monitorTargetBox .monitorTargetContent .el-button {
    border-radius: 0 50px 50px 0;
    height: 36px;
    box-sizing: border-box;
    width: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.handle-input2 {
    width: 300px !important;
    height: 36px;
    box-sizing: border-box;
}

/deep/ .handle-input2 .el-input__inner {
    height: 36px !important;
    box-sizing: border-box;
}

.selectTitleBox .leftTitle,
.rightTitle {
    font-size: 15px !important;
    /* font-weight: 600 !important; */
    width: 50%;
    background-color: #f0f2f5;
    border: 1px solid #d9d9d9;
    padding: 5px 10px;
}

.selectContentBox {
    background-color: #fff;
    border-left: 1px solid #d9d9d9;
    border-right: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
}

.selectContentBox .accountBox {
    height: 30px;
}

.selectContentBox .left {
    width: 50%;
    padding: 10px;
    height: 250px;
    overflow: scroll;
}

.selectContentBox .left1 {
    border-right: 1px solid #d9d9d9;
}


.selectContentBox .nodata {
    /* width: 100%; */
    padding: 10px;
    height: 90%;
}


.selectedAccountBox {
    background-color: #edf4ff;
    padding: 10px;
}

.productImg {
    height: 50px;
    width: 50px;
    border-radius: 5px;
}

.selectedAccountBox i {
    color: #409eff;
    cursor: pointer;
}

.yuan_box {
    position: absolute;
    top: 5px;
    right: 5px;
}

.addCondition {
    background-color: #edf4ff;
    padding: 5px 0;
    width: 500px;
    color: #4389f9;
    cursor: pointer;
}

.w100 {
    width: 100px;
}

.timePeriodBox {
    border: 1px solid #ddd;
    padding: 5px 30px;
    color: #555;
    cursor: pointer;
}

.activeTimePeriodBox {
    background-color: #409eff;
    color: #fff;
}



.yl-time-range-table {
    border-collapse: collapse;
    table-layout: fixed;
    -webkit-user-select: none;
    user-select: none;
    border-radius: 4px;
    width: 773px;
    border: 1px solid #e4e9ed;
    background-color: #fff;
}

.table_head {
    background-color: #f0f2f5;
    color: #555;
    /* padding: 10px; */
    /* width: 600px; */
    text-align: center;
}

.time_select_box {
    height: 40px !important;
    cursor: pointer;
    /* width: 20px !important; */
}

.time_select_box_inactive:hover {
    background-color: #f0f2f5;
}

.time_select_box_active {
    background-color: #409eff;
}

.time_select_box_active2 {
    background-color: rgba(64, 158, 255, 0.7);
    border-color: rgba(64, 158, 255, 0.7);
}

.drawer_footer {
    z-index: 1;
    background: #fff;
    align-items: center;
    height: 64px;
    padding: 0 20px;
    display: flex;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    box-shadow: 0 -4px 6px #00000014;
}

@media (max-width: 768px) {

    .monitorWayBox,
    .monitorTargetBox {
        padding: 15px;
    }

    .monitorWayBox .way_box {
        width: 20vw;
        box-sizing: border-box;
        height: 100px;
        /* height: 80px; */
        padding: 10px 5px;
    }


    .handle-input2 {
        font-size: 14px;
        width: 200px !important;
        height: 36px;
    }


    .addCondition {
        width: 300px;
    }

    .yl-time-range-table {
        width: 300px;
    }

    .dateSelector {
        transform: scale(0.8) !important;
        margin-left: -40px !important;
    }

    .productImg {
        height: 30px;
        width: 30px;
    }

    .selectedAccountBox {
        padding: 3px;
    }
}
</style>
